import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import { Close } from '@mui/icons-material';
import ListItemIcon from '@mui/material/ListItemIcon';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import RequestForm from '../forms/request/RequestForm';
import useAppStore from '../../store/app';
import { useNavigate, useRouteError } from 'react-router-dom';

export default function Unauthorized() {
  const state = useAppStore((state) => state.hero);
  const completeRequestForm = useAppStore((state) => state.completeRequestForm);
  const theme = useTheme();

  const error = useRouteError();

  console.log(error);

  const lg = useMediaQuery(theme.breakpoints.up('lg'));

  const navigate = useNavigate();

  const handleLogout = async () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('currentUserId');
    localStorage.removeItem('codeVerifier');
    navigate('/');
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '92px',
        px: '60px',
        [theme.breakpoints.down('md')]: {
          // mt: '120px',
          flexDirection: 'column-reverse',
          justifyContent: 'flex-start',
          alignItems: 'center',
        },
        [theme.breakpoints.down('sm')]: {
          gap: '60px',
        },
      }}
    >
      <Box
        sx={{
          maxWidth: '700px',
          [theme.breakpoints.down('md')]: {
            pb: '20%',
          },
          [theme.breakpoints.down('sm')]: {
            width: '100%',
            px: '24px',
          },
        }}
      >
        <Typography
          sx={{
            fontWeight: '800',
            fontSize: '48px',
            lineHeight: '1.2',
            [theme.breakpoints.down('sm')]: {
              fontSize: '28px',
            },
          }}
        >
          {error.status === 400 && 'Es ist ein unerwarteter Fehler aufgetreten'}
          {error.status === 401 &&
            'Leider fehlen Ihnen die nötigen Berechtigungen um diesen Inhalt zu sehen'}
          {error.status === 403 &&
            'Leider fehlen Ihnen die nötigen Berechtigungen um diesen Inhalt zu sehen'}
          {error.status === 500 && 'Es ist ein Serverfehler aufgetreten'}
          {error.code === 'ERR_NETWORK' && (
            <>
              Es ist ein{' '}
              <Typography
                sx={{
                  fontWeight: '800',
                  fontSize: '48px',
                  lineHeight: '1.2',
                  color: 'primary.main',
                  [theme.breakpoints.down('sm')]: {
                    fontSize: '28px',
                  },
                }}
              >
                Netzwerkfehler
              </Typography>{' '}
              aufgetreten
            </>
          )}
        </Typography>

        {error.status && (
          <Typography
            sx={{
              fontWeight: '800',
              fontSize: '48px',
              lineHeight: '1.2',
              color: 'primary.main',
              [theme.breakpoints.down('sm')]: {
                fontSize: '28px',
              },
            }}
          >
            Error {error.status}
          </Typography>
        )}

        <Accordion sx={{ width: '80%', mt: 2 }}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <Typography component="span">Fehlermeldung</Typography>
          </AccordionSummary>
          <AccordionDetails>
            {error?.response?.data?.message || error?.message}
          </AccordionDetails>
        </Accordion>

        <Typography
          sx={{
            mt: '22px',
            fontSize: '16px',
            [theme.breakpoints.down('sm')]: {
              fontSize: '14px',
            },
          }}
        >
          Über die folgende Schaltfläche gelangen sie zurück zur Startseite
        </Typography>

        <Button
          color="primary"
          sx={{
            mt: '32px',
            width: '180px',
            fontSize: '16px',
            fontWeight: '700',
            border: '3px solid',
            borderRadius: '0',
            '&:hover': {
              border: '3px solid primary.main',
            },
          }}
          variant="outlined"
          onClick={handleLogout}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <ListItemIcon sx={{ minWidth: 'unset' }}></ListItemIcon>
            <Typography variant="body1">Zurück</Typography>
          </Box>
        </Button>
      </Box>

      <Box
        sx={{
          flexShrink: 999,
          [theme.breakpoints.down('sm')]: {
            pt: '50px',
          },
        }}
      >
        {(state === 'graphics' || !lg) && (
          <img
            src="/static/access-denied_krem.svg"
            alt="Webdevelopment"
            style={{ maxWidth: '450px', width: '100%' }}
          />
        )}

        {state === 'form' && lg && <RequestForm />}
      </Box>

      <Dialog open={state === 'form' && !lg} onClose={completeRequestForm}>
        <Button
          sx={{
            position: 'absolute',
            top: '16px',
            right: '16px',
          }}
          onClick={completeRequestForm}
        >
          <Close />
        </Button>

        <DialogContent
          sx={{
            height: '50vh',
            minHeight: '550px',
            maxHeight: '90vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <RequestForm />
        </DialogContent>
      </Dialog>
    </Box>
  );
}
